export const FETCH_CONFIGURACOES_REQUEST = 'configuracoes/FETCH_CONFIGURACOES_REQUEST';
export const FETCH_CONFIGURACOES_SUCCESS = 'configuracoes/FETCH_CONFIGURACOES_SUCCESS';
export const FETCH_CONFIGURACOES_ERROR = 'configuracoes/FETCH_CONFIGURACOES_ERROR';
